<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-笔记-添加
    -->
    <el-dialog
    title="添加笔记"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="笔记介绍">
        <div class="edit_container">
          <Uediter v-model="form.context" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  


<el-form-item label="视频/图片" prop="media">
  <el-input v-model="form.media" placeholder="请输入视频或图片链接" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="发布时间" prop="publish_time">
  <el-date-picker v-model="form.publish_time" type="datetime" placeholder="选择发布时间" class="max-w460"></el-date-picker>
</el-form-item>

<el-form-item label="关联其他作者" prop="associated_authors">
  <el-input v-model="form.associated_authors" placeholder="请输入关联其他作者" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="提到的朋友" prop="mentioned_friends">
  <el-input v-model="form.mentioned_friends" placeholder="请输入提到的朋友" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="标签" prop="tags">
  <el-input v-model="form.tags" placeholder="请输入标签" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="笔记审核状态" prop="review_status">
  <el-select v-model="form.review_status" placeholder="选择审核状态" class="max-w460">
    <el-option label="待审核" value="pending"></el-option>
    <el-option label="已审核" value="approved"></el-option>
    <el-option label="未通过" value="rejected"></el-option>
  </el-select>
</el-form-item>

<el-form-item label="上架/恢复状态" prop="status">
  <el-select v-model="form.status" placeholder="选择状态" class="max-w460">
    <el-option label="上架" value="online"></el-option>
    <el-option label="恢复" value="offline"></el-option>
  </el-select>
</el-form-item>

<el-form-item label="笔记类型" prop="note_type">
  <el-select v-model="form.note_type" placeholder="选择笔记类型" class="max-w460">
    <el-option label="正式" value="official"></el-option>
    <el-option label="草稿" value="draft"></el-option>
  </el-select>
</el-form-item>

<el-form-item label="最后更新时间" prop="last_updated">
  <el-date-picker v-model="form.last_updated" type="datetime" placeholder="选择最后更新时间" class="max-w460"></el-date-picker>
</el-form-item>

<el-form-item label="阅读量" prop="views">
  <el-input v-model="form.views" placeholder="请输入阅读量" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="虚拟阅读量" prop="fview">
  <el-input v-model="form.fview" placeholder="请输入虚拟阅读量" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="点赞数" prop="likes">
  <el-input v-model="form.likes" placeholder="请输入点赞数" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="虚拟点赞数" prop="flikes">
  <el-input v-model="form.flikes" placeholder="请输入虚拟点赞数" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="分享数" prop="shares">
  <el-input v-model="form.shares" placeholder="请输入分享数" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="虚拟分享数" prop="fshares">
  <el-input v-model="form.fshares" placeholder="请输入虚拟分享数" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="是否推荐" prop="is_featured">
  <el-switch v-model="form.is_featured" active-text="推荐" inactive-text="不推荐"></el-switch>
</el-form-item>

<el-form-item label="是否置顶" prop="is_pinned">
  <el-switch v-model="form.is_pinned" active-text="置顶" inactive-text="不置顶"></el-switch>
</el-form-item>
     

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import NotesApi from '@/api/notes.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        context:"",
        media:"",
        publish_time:"",
        associated_authors:"",
        mentioned_friends:"",
        tags:[],
        review_status:"",
        status:0,
        type:0,
        last_updated:"",
        views:0,
        fview:0,
        likes:0,
        flikes:0,
        shares:0,
        fshares:0,
        is_featured:0,
        is_pinned:0,
      },
      loading: false,
      /*验证规则*/
      rules: {
       
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;

      form.context = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          NotesApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/notes/index/part/add.vue